import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import styled from "styled-components";

const DEFAULT_WIDTH = "330px";

const StyledDropdownButton = styled(DropdownButton)`
  > * {
    width: ${(props) => (props.width ? props.width : DEFAULT_WIDTH)};
  }

  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const renderItem = ({ name, id }, index) => (
  <Dropdown.Item key={`${name}-${index}`} eventKey={id}>
    {name}
  </Dropdown.Item>
);

const ViewDropdown = ({
  title,
  options,
  handler,
  onClick,
  headerTitle = "",
  useHeader = false,
  width = DEFAULT_WIDTH,
}) => (
  <StyledDropdownButton
    width={width}
    title={title}
    onSelect={handler}
    onClick={onClick}
    variant="secondary"
    id="dropdown-basic-button"
  >
    {useHeader && <Dropdown.Header>{headerTitle}</Dropdown.Header>}
    {options && options.map(renderItem)}
  </StyledDropdownButton>
);

export const viewDropDownSelect = (handler, options, id) => {
  handler({ id, name: options.filter((x) => x.id === id)[0].name });
};

export default ViewDropdown;
